import { Translate } from 'react-redux-i18n'
import { valToPercent } from '../../../helpers/value'
import { handleTHeadTitle } from '../portfolioProvince/helper'
import {
  COLUMN_ITEMS,
  CREDIT_RISK_SCORE_COL,
  TITLE_TABLE_INDUSTRY_TREND,
} from './constant'
import BaseCell from './table/BaseCell'
import FirstCellColumn from './table/FirstCellColumn'
import NumberCompanyCell from './table/NumberCompanyCell'

const {
  PERCENT_COMPANY,
  PERFORMANCE_SCORE,
  CREDIT_RISK_SCORE,
  COMPANY_NUMBER,
  INDUSTRY_NAME,
} = COLUMN_ITEMS

const MIN_LEVEL = 5
const MAX_LEVEL = 1

export const getSchema = (isCreditScore, isDynamicReport) => {
  const schema = [...TITLE_TABLE_INDUSTRY_TREND]
  if (isDynamicReport) schema.push(CREDIT_RISK_SCORE_COL)

  return schema.map((item, index, arr) => {
    const isPerformanceColumn = index === arr.length - 1 && !isCreditScore
    const colId = isPerformanceColumn ? PERFORMANCE_SCORE : item.key

    return {
      colId,
      title: isPerformanceColumn
        ? 'portfolio.segment.PERFORMANCE_SCORE'
        : item.title,
      isI18n: true,
      thStyle: item.thStyle,
      tdStyle: {
        ...item.tdStyle,
        minWidth: isDynamicReport ? 120 : item.tdStyle.minWidth,
      },
      renderTh:
        isDynamicReport && item.isChangeTitle
          ? () => (
              <div className="textEnd">
                <Translate
                  value={handleTHeadTitle(
                    isPerformanceColumn,
                    item,
                    isDynamicReport,
                  )}
                  dangerousHTML={true}
                />
              </div>
            )
          : undefined,
      render: (val, { rowId, locale, ...other }) => {
        return (
          {
            [INDUSTRY_NAME]: (
              <FirstCellColumn
                rowId={rowId}
                isDynamicReport={isDynamicReport}
              />
            ),
            [COMPANY_NUMBER]: (
              <NumberCompanyCell
                isDynamicReport={isDynamicReport}
                val={val}
                rowId={rowId}
                {...other}
              />
            ),
            [PERCENT_COMPANY]: valToPercent(val, locale),
            [CREDIT_RISK_SCORE]: (
              <BaseCell val={val} locale={locale} {...other} />
            ),
            [PERFORMANCE_SCORE]: (
              <BaseCell val={val} locale={locale} {...other} />
            ),
          }[colId] ?? val
        )
      },
    }
  })
}

export const sortByParentId = (items) => {
  const result = []
  findChild(items, result)
  return result
}

const findChild = (items, result, id) =>
  items
    .filter((item) => item.parentId === id)
    .forEach((item) => {
      result.push(item)
      findChild(items, result, item.id)
    })

export const initCollapseById = (treeData) => {
  return treeData.reduce((prev, cur) => {
    prev[cur.id] = {
      collapsedBy: [],
      isOpen: true,
      level: cur.level,
      name: cur.name,
      childrenIds: getChildrenIds(treeData, cur.id, cur.level),
    }
    return prev
  }, {})
}

export const getParentIds = (treeData, rowId, currentLevel) => {
  if (currentLevel === MAX_LEVEL) return []

  const currentIndex = treeData.findIndex((item) => item.id === rowId)

  const parentContainerArray = treeData.slice(0, currentIndex)
  return [...Array(currentLevel - MAX_LEVEL)].map((_, index) => {
    const parent = parentContainerArray.findLast(
      (element) => element.level === index + 1,
    )
    return parent?.id
  })
}

export const getChildrenIds = (treeData, rowId, currentLevel) => {
  if (currentLevel === MIN_LEVEL) return []

  const currentIndex = treeData.findIndex((item) => item.id === rowId)
  let nearIndexSampleLevel = treeData.findIndex(
    (item, index) => item.level === currentLevel && index > currentIndex,
  )
  if (nearIndexSampleLevel === -1) {
    nearIndexSampleLevel = treeData.length
  }

  return treeData
    .slice(currentIndex + 1, nearIndexSampleLevel)
    .map((item) => item.id)
}

export const getFirstCellColumnStyle = (level, isDynamicReport) => {
  return (
    {
      1: { fontWeight: 600, paddingLeft: 4 },
      2: { paddingLeft: 28 },
      3: { paddingLeft: isDynamicReport ? 28 : 52 },
      4: { paddingLeft: isDynamicReport ? 28 : 76 },
      5: { paddingLeft: isDynamicReport ? 28 : 116 },
    }[level] ?? {}
  )
}

export const hasCollapse = (dataById, childrenIds) => {
  const rowIdsHasData = Object.keys(dataById)
  return rowIdsHasData.some((item) => childrenIds.includes(Number(item)))
}
